(function () {
  function closePolicyModal(modal) {
    if (!modal) return;

    modal.hidden = true;
    document.documentElement.classList.remove('jc-policy-modal-open');
  }

  function openPolicyModal(policyKey) {
    const modal = document.querySelector('[data-jc-policy-modal]');

    if (!modal) return;

    modal.querySelectorAll('[data-jc-policy-panel]').forEach((panel) => {
      panel.hidden = panel.getAttribute('data-jc-policy-panel') !== policyKey;
    });

    modal.hidden = false;
    document.documentElement.classList.add('jc-policy-modal-open');

    const dialog = modal.querySelector('.jc-policy-modal__dialog');

    if (dialog) {
      dialog.scrollTop = 0;
      dialog.focus({ preventScroll: true });
    }
  }

  document.addEventListener('click', function (event) {
    const policyTrigger = event.target.closest('[data-jc-policy-open]');

    if (policyTrigger) {
      event.preventDefault();
      openPolicyModal(policyTrigger.getAttribute('data-jc-policy-open'));
      return;
    }

    const closeTrigger = event.target.closest('[data-jc-policy-close]');

    if (closeTrigger) {
      event.preventDefault();
      closePolicyModal(closeTrigger.closest('[data-jc-policy-modal]'));
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    closePolicyModal(document.querySelector('[data-jc-policy-modal]:not([hidden])'));
  });

  function openCookiePreferences(event) {
    const trigger = event.target.closest('[data-cookie-preferences-trigger]');

    if (!trigger) return;

    event.preventDefault();

    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
      return;
    }

    window.location.href = trigger.getAttribute('href') || '/pages/privacy-policy';
  }

  document.addEventListener('click', openCookiePreferences);
})();
